import api from '../../utils/api'
import ADPRefcodeService from '../admin/ADPRefcodeService';

const API_BASE_URL = "/ast/ASTInstrument";

const ASTInstrumentService = {
  async findAll(recordFilter: any): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all`, {
      params: recordFilter,
    });
    return response.data;
  },

  async getItemById(instrumentId: any): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one/${instrumentId}`);
    return response.data;
  },

  async create(item: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/create`, item);
    return response.data;
  },

  async update(instrumentId: string, item: any): Promise<any> {
    const response = await api.put(`${API_BASE_URL}/update/${instrumentId}`, item);
    return response.data;
  },

  async delete(instrumentId: string): Promise<any> {
    const response = await api.delete(`${API_BASE_URL}/delete/${instrumentId}`);
    return response.data;
  },

  async getItemByFacilityCode(facilityCode: any): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/get-dropdown-by-facility-code/${facilityCode}`);
    return response.data;
  },

  async getDropdown(moduleId: string, referenceGroup: string): Promise<any> {
    return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroup(moduleId, referenceGroup);
  },

  async uploadExcel(data: any[]): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/upload-excel`, data);
    return response.data;
  },

  async findOneNoAccess(instrumentId: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one-no-access/${instrumentId}`);
    return response.data;
  },

  async findAllInstrumentBySN(recordFilter: any): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all-by-sn`, {
      params: recordFilter,
    });
    return response.data;
  },

  async findOneInstrumentBySNAndEntity(snNo: string, entity: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one-by-sn-and-entity/${encodeURIComponent(snNo)}/${entity}`);
    return response.data;
  },

  async findOneByQrId(qrId: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one-by-qr-id/${qrId}`);
    return response.data;
  },

  async getEquipmentTypesByEntity(moduleId: string, referenceGroup: string, value1: string): Promise<any> {
    return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroupAndValue1(moduleId, referenceGroup, value1);
  },


};



export default ASTInstrumentService;